import { Component } from '@angular/core';

@Component({
  selector: 'mprd-bipt-redirection',
  templateUrl: './bipt-redirection.component.html',
  styleUrls: ['./bipt-redirection.component.css'],
})
export class BiptRedirectionComponent {
  constructor() {
    window.location.href = '../BIPT';
  }
}
